import React from 'react';
import OfferteGenerator from './components/OfferteGenerator';

function App() {
  return (
    <div className="App">
      <OfferteGenerator />
    </div>
  );
}

export default App;
